import { useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { exchangeAuthorizationCode, getAccessToken, redirectToLogin } from './sessionTokens'
import { FullScreenLoader } from '@/platform/ui/FullScreenLoader'

export function AuthCallbackPage() {
  const [params] = useSearchParams()
  const [error, setError] = useState<string | null>(null)
  const processingRef = useRef(false)
  const code = params.get('code')
  const returnTo = params.get('returnTo')
  const destination = returnTo?.startsWith('/') && !returnTo.startsWith('//') ? returnTo : '/'

  useEffect(() => {
    // 1. Nếu cookie đã có token (ví dụ cùng root domain .hocnhe.com), vào thẳng không cần exchange code
    if (getAccessToken()) {
      window.location.replace(destination)
      return
    }

    if (!code) {
      setError('Thiếu mã xác thực.')
      return
    }

    // 2. Chống StrictMode chạy 2 lần làm hỏng one-time authorization code
    if (processingRef.current) return
    processingRef.current = true

    void exchangeAuthorizationCode(code)
      .then(() => {
        window.location.replace(destination)
      })
      .catch((cause) => {
        if (getAccessToken()) {
          window.location.replace(destination)
          return
        }
        setError(cause instanceof Error ? cause.message : 'Không thể xác thực.')
      })
  }, [code, destination])

  if (!error) return <FullScreenLoader />

  return (
    <div className="screen-center">
      <section className="auth-card">
        <h1 className="text-xl font-bold text-slate-900">Xác thực chưa hoàn tất</h1>
        <p className="mt-2 text-sm text-slate-600">{error}</p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <button
            type="button"
            className="inline-flex h-10 items-center justify-center rounded-lg bg-orange-500 px-5 text-sm font-bold text-white hover:bg-orange-600"
            onClick={() => redirectToLogin(destination)}
          >
            Đăng nhập lại qua SSO
          </button>
          {getAccessToken() && (
            <button
              type="button"
              className="inline-flex h-10 items-center justify-center rounded-lg border border-slate-300 bg-white px-5 text-sm font-semibold text-slate-700 hover:bg-slate-50"
              onClick={() => window.location.replace(destination)}
            >
              Vào thẳng hệ thống
            </button>
          )}
        </div>
      </section>
    </div>
  )
}
